export enum ParentDrillingTypes {
  Row = 'rowParentDrilling',
  Column = 'columnParentDrilling'
}
